import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, Box } from '../../../ui'
import { Alert, Checkbox } from 'antd'
import { ButtonsBlock } from '../../../Edit/components'
import { useGetTariffRate } from '../../../hooks'
import {currencyFormat, signBody} from '../../../helpers'
import { fetchApprove } from '../../config'
import useRequest from '../../../hooks/useRequest'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'

interface IApproveModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    setActionConfirmed: (value: boolean) => void
    data: any
    total_cost_with_tax: string
    userData: any
    isSignExpired: boolean
    isEmptyAttorney: boolean
    isAttorneyExpired: boolean
}

const ApproveModal: FC<IApproveModal> = (
    {
        isModalVisible,
        setIsModalVisible,
        setActionConfirmed,
        data,
        total_cost_with_tax,
        userData,
        isSignExpired,
        isEmptyAttorney,
        isAttorneyExpired
    }
) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [checked, setIsChecked] = useState(false)
    const { fetch } = useRequest(fetchApprove)

    const { count, volume, ts_created } = data

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const { balance, rate, rateNumber } = useGetTariffRate({
        dependency: isModalVisible,
        id: 79,
        volume,
    })

    const getBack = () => {
        setIsModalVisible(false)
        setActionConfirmed(true)
        fetch({
            body: {
                fee: rateNumber,
                ts_created,
            },
            successMessage: {
                title: 'Успешно',
                description: `Данные сторонних инструментов успешно согласованы`,
            },
            errorCodeMessage: true,
            onSuccess: () => navigate('/user-my-green-tools'),
        })
    }

    const onChange = (e: any) => {
        setIsChecked(e.target.checked)
    }

    const confirmAgreement = async () => {
        const body = {
            fee: rateNumber,
            ts_created,
        }
        const { request_id, signature } = await signBody(body, userData)
        setIsModalVisible(false)
        setActionConfirmed(true)
        fetch({
            body,
            getParams: {
                request_id,
            },
            config: {
                headers: {
                    Signature: signature,
                },
            },
            successMessage: {
                title: 'Успешно',
                description: `Данные сторонних инструментов успешно согласованы`,
            },
            errorCodeMessage: true,
            onSuccess: () => navigate('/user-my-green-tools'),
        })
    }

    return (
        <Modal isModalVisible={isModalVisible} bodyStyle={{ width: '600px' }}>
            <div className={style.modalWrapper}>
                <div className={style.headerWrapper}>
                    <div className={style.header}>Согласование данных</div>
                </div>
            </div>
            <div className={style.infoWrapper}>
                <Box direction="row">
                    <div className={style.greyBlock}>Количество инструментов</div>
                    <div>{count}</div>
                </Box>
                <Box direction="row">
                    <div className={style.greyBlock}>Общий объем</div>
                    <div>{`${currencyFormat(volume)} кВт*ч`}</div>
                </Box>
            </div>
            <div className={style.payAlert}>
                <div className={style.payHeader}>
                    <span className={style.alertMessage}>Сумма комиссии составила </span>
                    <span className={style.alertPrice}>{total_cost_with_tax}</span>
                </div>
                <div className={style.payText}>
                    <span className={style.alertDetail}>Баланс платежного счета:</span>
                    <span className={style.alertDetail}> {balance}</span>
                </div>
            </div>
            <Checkbox checked={checked} className={style.checkbox} onClick={onChange}>
                {`Подтверждаю данные по сторонним инструментам`}
            </Checkbox>
            {isSignExpired && (
                <Alert
                    className={style.signError}
                    message={'Истек срок действия ЭП'}
                    type="error"
                    showIcon
                />
            )}
            {(isEmptyAttorney || isAttorneyExpired) && (
                <Alert
                    className={style.signError}
                    message={isEmptyAttorney ? t('profile.attorneyIsMissing') : t('profile.attorneyIsExpired')}
                    type="error"
                    showIcon
                />
            )}
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={confirmAgreement}
                    cancelAction={handleOk}
                    disableCondition={!checked}
                    confirmTitle="Подписать и оплатить"
                    confirmDisabled={isSignExpired || isEmptyAttorney || isAttorneyExpired}
                />
            </div>
        </Modal>
    )
}

export default ApproveModal
